/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import styles from './home.module.scss';

import loadable from '@loadable/component';
import CardShelf from '@/components/molecules/card-shelf';
const CareBinderBanner = loadable(() => import('@/components/molecules/care-binder-banner'));
import CarouselComponent from '@/components/molecules/carousel';
const HWGHBannerComponent = loadable(() => import('@/components/molecules/hwgh-banner'));
const SafetyChecklistBanner = loadable(() => import('@/components/molecules/safety-checklist-banner'));
const SelfCareWorkbookBanner = loadable(() => import('@/components/molecules/self-care-workbook'));
// import NFCSLogo from '@/assets/images/nfcs-logo.png';
/* TEMP commenting these out due to webpack issue
import NFCSBackground from '@/assets/images/nfcs/2023/post-nfcs-banner.png';
import NFCSBackgroundMobile from '@/assets/images/nfcs/2023/post-nfcs-banner-mobile.png';
import WalmartLogo from '@/assets/images/nfcs/2023/walmart-logo.png';*/
import HomeLoading from '@/components/pages/home/loading';
import CollectionCard from '@/components/molecules/collection-card';
import FullImageBanner from '@/components/molecules/full-image-banner';
import PartnerButton from '@/components/molecules/partner-button';
import { HOMEPAGE, COLLECTIONS } from '@/constants/endpoints.constant';
import { NavPills } from '@/constants/nav-pills.constant';
import { useHttpGet } from '@/hooks/use-http';
import { useNavPills } from '@/hooks/use-nav-pills.hook';
import { useTranslation } from '@/hooks';

const Home = () => {
  const { t } = useTranslation();
  const [navPills, setPills] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { execute: get, data, loading, error } = useHttpGet();
  const { execute: getCollections, data: fetchedCollections, loading: loadingCollections, error: errorCollections } = useHttpGet();

  const groups = data?.groups || [];
  useNavPills();

  useEffect(() => {
    get(HOMEPAGE);
  }, []);

  useEffect(() => {
    getCollections(COLLECTIONS + '?featured_only=true');
  }, []);

  useEffect(() => {
    let pills = [];
    if (groups && groups?.length > 0) {
      for (const group of groups) {
        if (!!group.nav) {
          pills.push({ label: group.label, url: group.url, type: NavPills.TYPE_CHILD })
        }
      }
    }
    if (pills.length > 0) {
      setPills(pills);
    }
  }, [data]);

  useNavPills('/', navPills);

  useEffect(() => {
    setIsLoading(loading || loadingCollections)
  }, [loading, loadingCollections])

  const displayLoading = () => {
    if (isLoading) {
      return <HomeLoading />;
    }
  }

  const DiscoverCollectionCard = ({ value }) => {
    return <CollectionCard bgImg={value.background_image?.location}
      title={value?.name}
      bodyColor={`#${value.color}`}
      description={value.description}
      link={value.url?.url}
      className={styles.cgHome__collectionCard}
    />
  }

  const shelfs = groups.map((item, key) =>
    <CardShelf
      showMoreLink={`/articles/${item.key}`}
      title={item.label}
      description={item.description}
      list={item.articles}
      key={key}
      className={styles.cgHome__subsection} />
  )

  shelfs.splice(1, 0, <CardShelf
    showMoreLink={'/collections'}
    title={t('moleculeTranslations.collectionBanner.shelfTitle')}
    description={t('moleculeTranslations.collectionBanner.shelfDescription')}
    list={fetchedCollections?.items || []}
    key={'collections'}
    className={`${styles.cgHome__subsection} ${styles.cgHome__collectionsCarousel}`}
    carouselSize={3}
    Card={DiscoverCollectionCard} />);

  const PartnerBannerText = () => {
    return <div>
      <h3 className={styles.cgHome__partnerBanner_heading}>{t('moleculeTranslations.partnerBannerHeader')}</h3>
      <p className={styles.cgHome__partnerBanner_desktop}>{t('moleculeTranslations.partnerBannerDescLong')}</p>
      <p className={styles.cgHome__partnerBanner_tablet}>{t('moleculeTranslations.partnerBannerDescShort')}</p>
    </div>
  }

  const PartnerSquareButton = () => {
    return <PartnerButton className={styles.cgHome__partnerBanner_button} />
  }

  return (
    <>{displayLoading()}
      {data && groups && !isLoading && !error && !errorCollections &&
        <div className={styles.cgHome}>
          <CarouselComponent
            className={styles.cgHome__banner_carousel}
            itemsDesktop={1}
            itemsDesktopSmall={1}
            itemsTablet={1}
            itemsMobile={1}
            partialVisibilityGutterMobile={0}
            autoPlaySpeed={10000}
            infinite
            showDots
            dotListClass={styles.cgHome__banner_carousel__list}>
            <FullImageBanner
              className={styles.cgHome__partnerBanner}
              src={'https://storage.googleapis.com/prod-caregiving-assets/images/banner_temp/partner_banner_desktop.webp'}
              tabletImg={'https://storage.googleapis.com/prod-caregiving-assets/images/banner_temp/partner_banner_tablet.webp'}
              mobileImg={'https://storage.googleapis.com/prod-caregiving-assets/images/banner_temp/partner_banner_mobile.webp'}
              description={PartnerBannerText()}
              CustomButton={PartnerSquareButton} btnlink={'https://partner.caregiving.com/'}
              classNameDescription={styles.cgHome__partnerBanner_description}
            >
              <h3 className={styles.cgHome__partnerBanner_heading}>{t('moleculeTranslations.partnerBannerHeader')}</h3>
              <p className={styles.cgHome__partnerBanner_desktop}>{t('moleculeTranslations.partnerBannerDescLong')}</p>
              <p className={styles.cgHome__partnerBanner_tablet}>{t('moleculeTranslations.partnerBannerDescShort')}</p>
            </FullImageBanner>
            {/*<FullImageBanner src={'https://storage.googleapis.com/prod-caregiving-assets/images/banner_temp/post-nfcs-banner.webp'}*/}
            {/*                 nfcs={true}*/}
            {/*                 button={t('moleculeTranslations.nfcs.register')}*/}
            {/*                 btnlink={'https://nfcs.caregiving.com/2023'}*/}
            {/*                 img={NFCSLogo}*/}
            {/*                 mobileImg={'https://storage.googleapis.com/prod-caregiving-assets/images/banner_temp/post-nfcs-banner-mobile.webp'}*/}
            {/*                 sponsor={'https://storage.googleapis.com/prod-caregiving-assets/images/banner_temp/walmart-logo.webp'}>*/}
            {/*  <div dangerouslySetInnerHTML={{__html: `${t('moleculeTranslations.nfcs.description')}`}}></div>*/}
            {/*</FullImageBanner>*/}
          </CarouselComponent>
          <div className={styles.cgHomeWrapper}>
            {shelfs}
          </div>
          <CarouselComponent
            className={styles.cgHome__carousel}
            itemsDesktop={2}
            itemsTablet={2}
            itemsMobile={1}
            partialVisibilityGutterMobile={0}
            autoPlaySpeed={5000}
            infinite
            showDots
            dotListClass={styles.cgHome__carousel__list}>
            <SafetyChecklistBanner />
            <CareBinderBanner />
            <SelfCareWorkbookBanner />
            <HWGHBannerComponent />
          </CarouselComponent>
        </div>}
    </>
  );
};

export default Home;
